import type { ActivationAlertsContractNewsTopic } from "@similarweb/pro-api-client";

import type { NewsMetricsDataType, NewsType } from "../types";

export const DEFAULT_TOPIC_KEY = "activation.alerts.cards.news.topic.news";

export const newsTypeTranslationKeyMap: Record<NewsType, string> = {
    Story: "activation.alerts.filters.news-type.story",
    PR: "activation.alerts.filters.news-type.pr",
    Mention: "activation.alerts.filters.news-type.mention",
};

export const newsMetricsDataTypeTranslationKeyMap: Record<NewsMetricsDataType, string> = {
    stories: "activation.alerts.news.metrics.data-type-label.stories",
    pressReleases: "activation.alerts.news.metrics.data-type-label.pressReleases",
    mentions: "activation.alerts.news.metrics.data-type-label.mentions",
};

export const topicFilterOptionTranslationKeyMap: Record<ActivationAlertsContractNewsTopic, string> = {
    Awards: "activation.alerts.filters.topic.option.awards",
    BoardAppointments: "activation.alerts.filters.topic.option.board-appointments",
    ClassActions: "activation.alerts.filters.topic.option.class-actions",
    ClosingDown: "activation.alerts.filters.topic.option.closing-down",
    Conferences: "activation.alerts.filters.topic.option.conferences",
    ContractsAndAgreements: "activation.alerts.filters.topic.option.contracts-and-agreements",
    DataBreaches: "activation.alerts.filters.topic.option.data-breaches",
    Esg: "activation.alerts.filters.topic.option.esg",
    ExpansionsAndLaunches: "activation.alerts.filters.topic.option.expansions-and-launches",
    FinancialResults: "activation.alerts.filters.topic.option.financial-results",
    InvestmentsAndFunding: "activation.alerts.filters.topic.option.investments-and-funding",
    LeadershipChanges: "activation.alerts.filters.topic.option.leadership-changes",
    LeadershipSays: "activation.alerts.filters.topic.option.leadership-says",
    LegalAndRegulatory: "activation.alerts.filters.topic.option.legal-and-regulatory",
    MergersAndAcquisitions: "activation.alerts.filters.topic.option.mergers-and-acquisitions",
    News: "activation.alerts.filters.topic.option.news",
    Partnerships: "activation.alerts.filters.topic.option.partnerships",
    Philanthropy: "activation.alerts.filters.topic.option.philanthropy",
    ProductRecalls: "activation.alerts.filters.topic.option.product-recalls",
    Rebrand: "activation.alerts.filters.topic.option.rebrand",
    Workforce: "activation.alerts.filters.topic.option.workforce",
};

export const topicTranslationKeyMap: Record<ActivationAlertsContractNewsTopic, string> = {
    Awards: "activation.alerts.cards.news.topic.awards",
    BoardAppointments: "activation.alerts.cards.news.topic.board-appointments",
    ClassActions: "activation.alerts.cards.news.topic.class-actions",
    ClosingDown: "activation.alerts.cards.news.topic.closing-down",
    Conferences: "activation.alerts.cards.news.topic.conferences",
    ContractsAndAgreements: "activation.alerts.cards.news.topic.contracts-and-agreements",
    DataBreaches: "activation.alerts.cards.news.topic.data-breaches",
    Esg: "activation.alerts.cards.news.topic.esg",
    ExpansionsAndLaunches: "activation.alerts.cards.news.topic.expansions-and-launches",
    FinancialResults: "activation.alerts.cards.news.topic.financial-results",
    InvestmentsAndFunding: "activation.alerts.cards.news.topic.investments-and-funding",
    LeadershipChanges: "activation.alerts.cards.news.topic.leadership-changes",
    LeadershipSays: "activation.alerts.cards.news.topic.leadership-says",
    LegalAndRegulatory: "activation.alerts.cards.news.topic.legal-and-regulatory",
    MergersAndAcquisitions: "activation.alerts.cards.news.topic.mergers-and-acquisitions",
    News: "activation.alerts.cards.news.topic.news",
    Partnerships: "activation.alerts.cards.news.topic.partnerships",
    Philanthropy: "activation.alerts.cards.news.topic.philanthropy",
    ProductRecalls: "activation.alerts.cards.news.topic.product-recalls",
    Rebrand: "activation.alerts.cards.news.topic.rebrand",
    Workforce: "activation.alerts.cards.news.topic.workforce",
};
